import { useRef } from 'react';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';

interface LightBeamProps {
  intensity: number;
}

export function LightBeam({ intensity }: LightBeamProps) {
  const meshRef = useRef<THREE.Mesh>(null);
  const materialRef = useRef<THREE.MeshStandardMaterial>(null);

  // Normalize intensity to a 0-1 range (assuming typical light range of 0-1000 lux)
  const normalizedIntensity = Math.max(0, Math.min(1, intensity / 1000));

  useFrame((state) => {
    if (meshRef.current && materialRef.current) {
      // Rotating effect
      meshRef.current.rotation.y = state.clock.elapsedTime * 0.5;

      // Update material properties
      materialRef.current.opacity = 0.2 + normalizedIntensity * 0.3;
      materialRef.current.emissiveIntensity = normalizedIntensity * 0.8;
    }
  });

  return (
    <mesh ref={meshRef} position={[0, 0, 0]}>
      <coneGeometry args={[1, 3, 32]} />
      <meshStandardMaterial
        ref={materialRef}
        color="#ffd43b"
        transparent
        opacity={0.2}
        emissive="#ffd43b"
        emissiveIntensity={0.4}
        side={THREE.DoubleSide}
      />
    </mesh>
  );
} 